export default __webpack_public_path__ + "static/media/img-empty-graph.188bec62.png";